import { render, staticRenderFns } from "./BarraBusca.vue?vue&type=template&id=47160e77"
import script from "./BarraBusca.vue?vue&type=script&lang=js"
export * from "./BarraBusca.vue?vue&type=script&lang=js"
import style0 from "./BarraBusca.vue?vue&type=style&index=0&id=47160e77&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports